import { render, staticRenderFns } from "./FolderMediaDelete.vue?vue&type=template&id=150b11b5&scoped=true&"
import script from "./FolderMediaDelete.vue?vue&type=script&lang=js&"
export * from "./FolderMediaDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "150b11b5",
  null
  
)

export default component.exports